var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-169"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 55.42,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 397.86,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.46,
    y: 391.8,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.56,
    y: 391.8,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.21,
    y: 395.31,
    width: 46.84,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.93,
    y: 248.86,
    width: 20,
    height: 133.65,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.66 382.51 434.92 382.51 434.92 364.31 424.15 364.31 429.66 382.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.56,
    y: 248.86,
    width: 20,
    height: 133.65,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.96,
    y: 248.86,
    width: 188.96,
    height: 122.48,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.34,288.38H249.54V253.79h181.8Zm-180.8-1h179.8V254.79H250.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,264.73H285.08c-5.13,0-10-4.15-13.57-11.46H412.9C409.37,260.58,404.47,264.73,399.34,264.73Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 382.51 245.96 382.51 245.96 364.31 256.73 364.31 251.22 382.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.34,327.4H249.54V292.81h181.8Zm-180.8-1h179.8V293.81H250.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,303.75H285.08c-5.13,0-10-4.15-13.57-11.46H412.9C409.37,299.6,404.47,303.75,399.34,303.75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.34,366.41H249.54V331.82h181.8Zm-180.8-1h179.8V332.82H250.54Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,342.76H285.08c-5.13,0-10-4.14-13.57-11.46H412.9C409.37,338.62,404.47,342.76,399.34,342.76Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,217.18l16,13.54c-.81,98.18,2.8,103.5,2.88,120.39H142.12C139.58,268.93,132.39,238.27,141.54,217.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,380.36h0c-25.75,0-47.48-10.45-52.76-24.58a46.71,46.71,0,0,0-5.5-11l-.41-.57H208.23l-.4.57a46.71,46.71,0,0,0-5.5,11C197,369.91,175.32,380.36,149.56,380.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.47,347.76H90.65a7.19,7.19,0,0,1-7-5.39h0a7.17,7.17,0,0,1,7-9H208.47a7.17,7.17,0,0,1,6.95,9h0A7.17,7.17,0,0,1,208.47,347.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,252c2.39-25.6,17.6-26.45,54.66-1.95C190.31,311.46,142,348.26,151,252Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,213.55c-4.36-22.17,17.29-52.63,54.63-41.22C202.56,230.86,161.89,297.09,145.48,213.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06,209.89c5.53-27.75-28.47-75.34-62.95-69.11C76.57,181.83,139.35,338.76,165.06,209.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.34,252.21c-12.87-38.69-52.15-49.78-77.27-5.86C112.68,317.24,182.36,345.45,151.34,252.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.28,
    y: 83.63,
    width: 150.67,
    height: 135,
    transform: "translate(197.49 499.74) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.17,
    y: 150.51,
    width: 150.67,
    height: 1.22,
    transform: "translate(129.38 431.63) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.11,
    y: 85.79,
    width: 115,
    height: 130.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.63,
    y: 82.12,
    width: 32.39,
    height: 45.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.76 82.13 339.38 82.13 337.05 127.46 369.43 127.46 371.76 82.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.46 134.08 300.07 134.08 297.74 179.42 330.13 179.42 332.46 134.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.24,
    y: 82.13,
    width: 32.38,
    height: 45.33,
    transform: "translate(4.97 -17.1) rotate(2.51)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.32,
    y: 144.02,
    width: 32.38,
    height: 45.33,
    transform: "translate(-4.67 10.47) rotate(-1.66)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.13,88.46H212a3.17,3.17,0,0,0,3.17-3.17h0A3.16,3.16,0,0,0,212,82.13H56.13A3.16,3.16,0,0,0,53,85.29h0A3.17,3.17,0,0,0,56.13,88.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.13,101.88H212a3.17,3.17,0,0,0,3.17-3.17h0A3.17,3.17,0,0,0,212,95.54H56.13A3.17,3.17,0,0,0,53,98.71h0A3.17,3.17,0,0,0,56.13,101.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.96,
    y: 108.96,
    width: 162.22,
    height: 6.33,
    rx: 3.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.91,88.46H224.8A3.16,3.16,0,0,0,228,85.29h0a3.15,3.15,0,0,0-3.16-3.16H68.91a3.16,3.16,0,0,0-3.17,3.16h0A3.17,3.17,0,0,0,68.91,88.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.91,101.88H224.8A3.16,3.16,0,0,0,228,98.71h0a3.16,3.16,0,0,0-3.16-3.17H68.91a3.17,3.17,0,0,0-3.17,3.17h0A3.17,3.17,0,0,0,68.91,101.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.74,
    y: 108.96,
    width: 162.22,
    height: 6.33,
    rx: 3.17,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-169"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-169",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.77,131.44c-1.94-.41-4.43-3.16-4.71-7.83-.34-6,6.15-6.34,9.29-4.91S396.75,128.13,390.77,131.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.01 393.13 432.54 395.66 425.56 378.5 433.02 375.97 440.01 393.13",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36,395.09l9.09-3.08a.6.6,0,0,1,.76.31l3.1,6.45a1.31,1.31,0,0,1-.77,1.76c-2.94.94-5.12,1.49-8.8,2.74-2.27.77-6.8,2.42-9.93,3.48s-4.3-2-3.09-2.77c5.45-3.27,7.1-5.64,8.54-8A2.09,2.09,0,0,1,431.36,395.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.02 375.97 425.56 378.5 429.16 387.35 436.63 384.82 433.02 375.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,160.33h6c-2,1.7-1.82,47.42-.13,69.37-4.79.3-13.57-1.37-13.57-1.37S384.19,194.11,392.73,160.33Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,160.33h6c-2,1.7-1.82,47.42-.13,69.37-4.79.3-13.57-1.37-13.57-1.37S384.19,194.11,392.73,160.33Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.54 408.14 381.6 408.14 380.41 389.76 388.34 389.76 389.54 408.14",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.34 389.77 380.41 389.77 381.03 399.24 388.96 399.24 388.34 389.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54,396l14.16-.12s-2.38-51.73-.88-76.36c.46-7.5.37-17.89,2.48-29.07,2.68-14.09,6.11-29.34,8.94-41.27,3-12.58,1.42-21.48,1.42-21.48l-27.89-1.65s-7.21,66-7.22,90.18C367.53,341.44,376.54,396,376.54,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.65,407.22h9.67a.61.61,0,0,1,.63.54l.9,7.05a1.3,1.3,0,0,1-1.3,1.41c-3.11-.05-5.36-.23-9.28-.23-2.41,0-11.12.25-14.45.25s-3.45-3.29-2.06-3.59c6.24-1.34,12.43-3.18,14.56-4.94A2.06,2.06,0,0,1,380.65,407.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.41 397.72 393.63 397.72 393.52 392.61 374.45 392.28 375.41 397.72",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.89,408.6a2.23,2.23,0,0,1-1.48-.4,1,1,0,0,1-.3-1,.66.66,0,0,1,.37-.53c.92-.46,3.33,1.12,3.61,1.3a.17.17,0,0,1,.06.19.23.23,0,0,1-.15.15A10,10,0,0,1,377.89,408.6Zm-1-1.64a.62.62,0,0,0-.25.05.28.28,0,0,0-.14.22.73.73,0,0,0,.19.68c.4.37,1.44.42,2.81.15A6.92,6.92,0,0,0,376.87,407Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,408.33a.11.11,0,0,1-.08,0c-.78-.44-2.21-2.18-1.95-3.07a.69.69,0,0,1,.64-.49,1,1,0,0,1,.78.24c.85.76.82,3,.82,3.14a.19.19,0,0,1-.1.17A.17.17,0,0,1,380,408.33Zm-1.29-3.22h-.09c-.25,0-.28.15-.29.19-.15.53.74,1.84,1.49,2.46a4.16,4.16,0,0,0-.7-2.49A.59.59,0,0,0,378.66,405.11Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.3,290.49c2.68-14.09,6.11-29.34,8.94-41.27L398.15,243C391.52,251.3,390.51,276.71,392.3,290.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.82,227s9.13,67.89,13.24,90.86c4.51,25.15,21.84,69,21.84,69l13.67-4.64s-10.77-36.38-14.55-61c-4.31-28-6.83-92.62-6.83-92.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.4 387.69 440.54 381.88 438.8 377.03 420.76 382.8 423.4 387.69",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.21,397.29a2.17,2.17,0,0,1-1.53.09,1,1,0,0,1-.6-.85.7.7,0,0,1,.18-.63c.72-.72,3.49,0,3.81.1a.15.15,0,0,1,.12.16.2.2,0,0,1-.1.19A8.9,8.9,0,0,1,429.21,397.29Zm-1.49-1.24a.48.48,0,0,0-.22.13.26.26,0,0,0-.06.25.71.71,0,0,0,.4.59c.49.22,1.48-.06,2.68-.76A6.91,6.91,0,0,0,427.72,396.05Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,396.37H431c-.87-.18-2.76-1.39-2.81-2.31a.7.7,0,0,1,.45-.68,1,1,0,0,1,.81,0c1,.45,1.74,2.65,1.77,2.74a.21.21,0,0,1,0,.2A.15.15,0,0,1,431.05,396.37Zm-2.24-2.66-.08,0c-.22.11-.22.23-.22.28,0,.54,1.28,1.52,2.19,1.87-.24-.63-.78-1.87-1.45-2.15A.57.57,0,0,0,428.81,393.71Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.55,169.72c-3.52,4.48-7.14,8.65-11,12.77a149.69,149.69,0,0,1-12.31,11.78c-1.14.92-2.25,1.85-3.48,2.73a20.7,20.7,0,0,1-4.63,2.76,20.09,20.09,0,0,1-10.65,1.08,30.82,30.82,0,0,1-9-2.92,36.36,36.36,0,0,1-3.9-2.22A36,36,0,0,1,324,193l3.26-5c4.58,1.88,9.77,3.38,14.1,3.35a10.83,10.83,0,0,0,5.42-1.27,14.51,14.51,0,0,0,2.23-1.72c.95-.79,1.88-1.69,2.81-2.55,1.87-1.79,3.72-3.63,5.52-5.58s3.61-3.89,5.38-5.89c3.53-4,7.07-8.11,10.43-12.16Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,175.91a85.25,85.25,0,0,1-10.29,9.9l-2.65-2.46-9.46-8.77a45.86,45.86,0,0,1,10.38-13.17c7.44-6.63,16.26-4.52,17.27,3.76C387.28,168.25,384.76,172.25,381.65,175.91Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,175.91a85.25,85.25,0,0,1-10.29,9.9l-2.65-2.46C371.21,178.15,380,169,381.65,175.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.64,237.78c3.76,1.58,9.51,2.63,14.42,1.11-.33-7.43-.22-49.33,7.18-78.6l4.38,0c-2,1.63-8.1,56.38-6.1,79.16,8.39,1.75,24.88.41,27.48-2.16-.33-3.58-2.14-21.46-1.89-33.94.11-5.32.35-11.19.9-17.35a175.65,175.65,0,0,1,4.18-26.15s-5-1.33-10.73-2.19c-1.13-.17-2.28-.32-3.41-.44a157.32,157.32,0,0,0-18-1.07c-.74,0-1.47.06-2.18.11a82.57,82.57,0,0,0-10.08,1.36S367.08,193.61,371.64,237.78Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.22,172.26c-2.09,6.33-2,15.1,1,19.23.12.17.25.33.37.47q.18-2.91.45-5.92c.27-3.07.62-6.22,1.05-9.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,136.87c-1.35,5.73-2.87,16.28,1,20.39a17.7,17.7,0,0,1-14.1,4.7c-5-.41-5.11-3.91-3.93-5.77,6.53-1.16,6.54-6,5.57-10.53Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,140.46l-6.75,5.19a19.26,19.26,0,0,1,.44,3.23c2.48-.21,6-2.72,6.33-5.29A8.58,8.58,0,0,0,402.34,140.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,127.32c-.67,7.86-.67,12.49-4.72,16.35-6.1,5.8-15.68,1.74-17.36-6.2-1.51-7.16-.16-18.8,7.59-21.57A11,11,0,0,1,408,127.32Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,132.28c-1.94-.4-4.44-3.16-4.71-7.83-.35-6,6.15-6.34,9.28-4.91S413.52,129,407.55,132.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,121.94c-3.6,1.42-17.61.91-19.81-2.68S411,119.13,403.87,121.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.29,121c-3.7,1.1-17.62-.6-19.5-4.36S412.65,118.75,405.29,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.16,120.42c-3.78.76-17.49-2.19-19-6.11S414.69,118.9,407.16,120.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6,120.8c-3.83.48-17.45-4.65-18.69-8.67S417.22,119.85,409.6,120.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.09,120c-3.86.09-16.84-5.22-17.67-9.34S418.77,119.78,411.09,120Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,119.93c-3.18-.61-14.56-7.49-14.21-11C397.71,105,417.92,121.15,411.53,119.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.27,133.48a7.24,7.24,0,0,1-3.4,4.52c-2.26,1.29-4.09-.59-4-3.06,0-2.23,1.28-5.58,3.83-5.86A3.43,3.43,0,0,1,411.27,133.48Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,129c0,.64-.37,1.14-.79,1.13s-.74-.56-.72-1.2.36-1.15.78-1.13S396,128.33,396,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.82,128.63c0,.64-.37,1.15-.79,1.13s-.74-.56-.72-1.2.36-1.14.78-1.12S388.83,128,388.82,128.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,129.06a22.35,22.35,0,0,1-3.18,5.34,3.7,3.7,0,0,0,3,.72Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.6,137a5.69,5.69,0,0,1-.83,0,.18.18,0,0,1-.18-.19.18.18,0,0,1,.19-.18,4.93,4.93,0,0,0,4.17-1.8.19.19,0,0,1,.26,0,.21.21,0,0,1,.05.27A5.21,5.21,0,0,1,393.6,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.31,126.73a.38.38,0,0,1-.35-.16,3,3,0,0,0-2.37-1.37.39.39,0,0,1-.39-.37.36.36,0,0,1,.36-.38,3.79,3.79,0,0,1,3,1.69.39.39,0,0,1-.08.53A.32.32,0,0,1,398.31,126.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.77,126a.32.32,0,0,1-.21,0,.37.37,0,0,1-.16-.51,3.63,3.63,0,0,1,2.74-2,.39.39,0,0,1,.41.35.37.37,0,0,1-.33.41,2.84,2.84,0,0,0-2.16,1.6A.37.37,0,0,1,385.77,126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7,165.16c1.23,2.77,2.19,5.41,3.18,8.14s1.84,5.48,2.64,8.28a90.88,90.88,0,0,1,3.31,17.48l.11,2.34v.67l0,.92c0,.6-.13,1.11-.21,1.65a22,22,0,0,1-1.76,5.13,48.73,48.73,0,0,1-4.79,7.87,93.35,93.35,0,0,1-11.58,12.94l-4.53-3.88c2.91-4.59,5.82-9.32,8.3-14a52,52,0,0,0,3.11-6.88,13.51,13.51,0,0,0,.67-2.87c0-.15,0-.33,0-.43a.53.53,0,0,1,0-.12v-.15l0-.23-.23-1.83a101.63,101.63,0,0,0-3.78-15.2c-.8-2.55-1.69-5.1-2.59-7.64s-1.9-5.11-2.83-7.48Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.55,161.05c6.41,4.19,9.38,21.26,9.38,21.26l-15.1,6.52a44.47,44.47,0,0,1-7.38-16.7C409.31,161.26,418,156.75,424.55,161.05Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.9,225.54l-9.31-.36,4.9,9s6.75-1.86,6.08-5.55Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.63 229.48 407.02 236.7 412.49 234.14 407.59 225.18 402.63 229.48",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,188.3l-6.9-4.32-1.15,10s6.66,2.39,8.24-1Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.89 185.42 311.98 192.92 319.54 194.02 320.69 183.98 313.89 185.42",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.82,134.38c-5.76,6.09-14.39,21.9-7.77,27.45a19,19,0,0,0,14.63.17l-1.55-22.83S266.32,130.38,261.82,134.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,186.72a95.66,95.66,0,0,1-2.82,9.24c-1.08,3-2.32,5.95-3.68,8.86a71.37,71.37,0,0,1-4.65,8.52c-.88,1.38-1.83,2.73-2.83,4.06-.5.66-1,1.32-1.56,2-.27.32-.56.63-.84.95l-.42.48a8.41,8.41,0,0,1-.9.85,6.73,6.73,0,0,1-2.48,1.24,7.16,7.16,0,0,1-2.52.17,9.71,9.71,0,0,1-3.52-1.14,21.94,21.94,0,0,1-4.45-3.28,60.91,60.91,0,0,1-6.53-7.25,129.78,129.78,0,0,1-10.32-15.73l3.65-2.37c1.86,2.35,3.77,4.75,5.72,7.06s3.91,4.61,6,6.77a60.43,60.43,0,0,0,6.27,6,15.18,15.18,0,0,0,3.08,2,2.14,2.14,0,0,0,.86.23s-.06,0-.23,0a1.48,1.48,0,0,0-.46.19.13.13,0,0,1-.06.05h0l.32-.41c.22-.27.44-.53.65-.81.42-.56.83-1.12,1.23-1.71.79-1.16,1.55-2.36,2.26-3.62,1.42-2.49,2.69-5.12,3.89-7.79s2.24-5.44,3.22-8.23,1.88-5.68,2.63-8.37Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5,188.94c-.93,2.61-4.09,7.29-6.57,10.75-1.81,2.5-3.25,4.36-3.25,4.36l-1.43-1L240.41,195c2.23-6.77,5.19-14,13.45-16C259.06,177.76,265.16,184.28,263.5,188.94Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.5,188.94c-.93,2.61-4.09,7.29-6.57,10.75-1.81,2.5-3.25,4.36-3.25,4.36l-1.43-1L240.41,195c2.23-6.77,5.19-14,13.45-16C259.06,177.76,265.16,184.28,263.5,188.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,199.69c-1.81,2.5-3.25,4.36-3.25,4.36l-1.43-1c.71-2.7,2-6.93,3.88-8.61A12.59,12.59,0,0,1,256.93,199.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.15,195.16l.39-7.44-8.9,1.24s2.51,5.71,5.16,8.1Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.66 184.62 205.22 186.77 205.64 188.96 214.54 187.72 211.66 184.62",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.7 407.92 277.27 408.74 271.66 388.97 280.09 388.16 285.7 407.92",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.54 388.91 338.73 392.5 327.9 375.57 335.71 371.98 346.54 388.91",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,389.87,345,385.4a.69.69,0,0,1,.88.21l4.51,6.26a1.39,1.39,0,0,1-.52,2c-3,1.5-4.54,2.08-8.31,4-2.31,1.21-7.26,4.23-10.46,5.89s-5-1.4-3.84-2.38c5.31-4.4,7-7.68,8.14-10.42A2.32,2.32,0,0,1,336.4,389.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.76,406.17H286a.84.84,0,0,1,.8.62l2.22,8.07a1.26,1.26,0,0,1-1.24,1.61c-3.6,0-5.3,0-9.79,0H264.24c-3.72,0-4.5-3.77-3-4.11,6.91-1.53,10.9-3.64,13-5.65A2.07,2.07,0,0,1,275.76,406.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.66 388.97 274.56 399.16 283.22 399.16 280.1 388.16 271.66 388.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.72 371.98 327.9 375.57 333.49 384.3 341.3 380.71 335.72 371.98",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,226.13l-34.63,4.43c-14.56-49-10.9-50.78-10.9-50.78s5.78-2,11.68-3.54c.89-.23,1.79-.45,2.67-.65a112.5,112.5,0,0,1,15.73-2l2.33-.15a105.81,105.81,0,0,1,12.63.2c-.64,6.31-1.1,11.65-1.39,16.32-.39,6.08-.51,11-.42,15.26A132.47,132.47,0,0,0,297.1,226.13Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.1,226.13l-34.63,4.43c-14.56-49-10.9-50.78-10.9-50.78s5.78-2,11.68-3.54c.89-.23,1.79-.45,2.67-.65a112.5,112.5,0,0,1,15.73-2l2.33-.15a105.81,105.81,0,0,1,12.63.2c-.64,6.31-1.1,11.65-1.39,16.32-.39,6.08-.51,11-.42,15.26A132.47,132.47,0,0,0,297.1,226.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.8,205.2c-2.34-5-3.48-15.91-2-19.65l2.42,4.39C294.83,196,294.71,200.92,294.8,205.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.84,163.1c.32,4.28,1.33,8.64,3.81,10.47a29.73,29.73,0,0,0-10.59,5.71c-4.25-2.24-5.13-3.69-5.13-3.69,5.47-2.07,5.09-5.83,2.77-11.87l4.27-2.3A2.8,2.8,0,0,1,277.84,163.1Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,172.17c-1.51-.69-4.34,3.05-4.72,4.05s1.16,1.31,1,2.63.72,2.49,3.33,3.52,7.78.41,9.5-2.15,12.44-4.61,10.94-7.16-2.66-1.12-3.72-3.67-5.55-.11-7,1.22S273.36,175.06,267,172.17Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,161.41a2.79,2.79,0,0,1,4.8,1.3,17.3,17.3,0,0,1-7.47,7.65,18.46,18.46,0,0,0-1.6-6.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,149.68c-2.12,8.27-2.84,11.81-7.89,15.29-7.6,5.23-17.29.82-17.68-7.91-.35-7.86,3.18-20.06,12-21.81A11.64,11.64,0,0,1,284.48,149.68Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.88,157.82a6.2,6.2,0,0,1-3.5,3.23c-2.06.75-3.25-1.06-2.81-3.08.4-1.82,1.95-4.41,4.08-4.27A2.8,2.8,0,0,1,284.88,157.82Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.61,140.19c4.06-.83,13.81-.14,14.66,3.85-3.47,3.24-1.8,13.68-5.41,16.74,5.27,5,15.72,5.05,15.72,5.05s10.33-28.07-2.28-29.44c-2.65-7.1-17-7.74-24.48-2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,144.43H278a.66.66,0,0,1-.66-.66h0a.67.67,0,0,1,.66-.66H283a.66.66,0,0,1,.66.66h0A.65.65,0,0,1,283,144.43Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.47,230.57s-13.3,66.93-8.87,92.78c4.25,24.78,17.32,72.86,17.32,72.86l14.83-.38s-9.31-55.71-9.49-76.42c-.31-34.35,11.57-92.09,11.57-92.09Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.99 396.98 287.15 396.51 286.09 390.88 267.5 391.83 269.99 396.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.55,238.68l5.93-10.42,7.35-.94s-5.41,26.26-8.83,53.89C274.89,268,273.44,244.76,274.55,238.68Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,229.7s10.51,56.62,19.88,88.95c7.56,26.11,39.3,61.69,39.3,61.69l11.22-5.63s-21.3-39.42-26.58-57.16c-16.89-56.76-3.68-77.39-16.76-91.42Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.3 383.8 342.51 376.98 340.53 371.35 325.94 379.45 329.3 383.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,224l2,2.9c.15.22-.1.51-.5.56l-36.33,4.66c-.31,0-.59-.08-.63-.28l-.71-3.06c0-.21.2-.43.54-.47l35.07-4.5A.63.63,0,0,1,297.36,224Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,224l2,2.9c.15.22-.1.51-.5.56l-36.33,4.66c-.31,0-.59-.08-.63-.28l-.71-3.06c0-.21.2-.43.54-.47l35.07-4.5A.63.63,0,0,1,297.36,224Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15,228.56l.94-.13c.19,0,.32-.13.29-.25l-1-4c0-.12-.2-.19-.39-.17l-.94.12c-.18,0-.31.14-.29.26l1,4C292.79,228.5,293,228.58,293.15,228.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.18,232.14l.94-.12c.18,0,.31-.14.29-.25l-1-4c0-.12-.21-.2-.39-.17l-.94.12c-.19,0-.32.14-.29.25l1,4C264.81,232.09,265,232.17,265.18,232.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.16,230.35l.94-.12c.19,0,.32-.14.29-.26l-.95-4c0-.11-.21-.19-.39-.17l-.94.12c-.19,0-.32.14-.29.26l.95,4C278.8,230.3,279,230.37,279.16,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32,149.33c-.13.68-.6,1.16-1,1.07s-.7-.7-.57-1.38.6-1.17,1-1.08S270.45,148.65,270.32,149.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.62,147.85c-.13.68-.59,1.16-1,1.07s-.7-.7-.57-1.38.6-1.17,1.05-1.08S262.76,147.16,262.62,147.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,146.53l-1.55-.78S261.29,147.19,262.25,146.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,149.37a18.6,18.6,0,0,1-3.26,3.88,3,3,0,0,0,2.34.93Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,157.57a.2.2,0,0,1-.09-.2.21.21,0,0,1,.24-.17,5.46,5.46,0,0,0,4.8-1.26.21.21,0,0,1,.29,0,.19.19,0,0,1,0,.28,5.78,5.78,0,0,1-5.18,1.38A.11.11,0,0,1,266.34,157.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,147.23a.36.36,0,0,1-.14-.16,3.24,3.24,0,0,0-2.3-1.83.4.4,0,0,1-.36-.45.42.42,0,0,1,.45-.36,4,4,0,0,1,2.94,2.28.41.41,0,0,1-.18.55A.43.43,0,0,1,273,147.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.93,143.83l0-.07a.4.4,0,0,1,.27-.5,4,4,0,0,1,3.67.6.41.41,0,0,1-.53.63,3.16,3.16,0,0,0-2.9-.45A.42.42,0,0,1,259.93,143.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,182.37c1.14,1.23,2.09,2.35,3.06,3.57s1.9,2.41,2.81,3.64c1.79,2.48,3.48,5,5,7.69a73.78,73.78,0,0,1,4.23,8.26c.33.71.6,1.45.9,2.17s.58,1.45.83,2.2.51,1.45.77,2.28l.36,1.34.26,1.33a29.89,29.89,0,0,1-.35,10,54.76,54.76,0,0,1-2.65,9,90.84,90.84,0,0,1-3.77,8.33A85.57,85.57,0,0,1,307,250l-3.76-2.22c1.18-2.54,2.34-5.23,3.33-7.9a83.14,83.14,0,0,0,2.69-8.08,53.65,53.65,0,0,0,1.65-8.08,32.71,32.71,0,0,0,.22-3.91,20.68,20.68,0,0,0-.39-3.61l-.2-.82-.25-.78c-.2-.56-.5-1.25-.75-1.86s-.53-1.26-.83-1.89-.56-1.25-.89-1.86c-1.23-2.48-2.68-4.87-4.14-7.26s-3.1-4.68-4.79-6.93c-.83-1.14-1.69-2.26-2.57-3.36s-1.8-2.21-2.63-3.16Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,245.38l-6.9,3.37,7.08,5.53s3.07-3.7,2.94-7.27Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.82 255.59 300.84 258.71 305.13 254.28 298.05 248.75 294.82 255.59",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,173.62c4.29.58,10.77,12.56,10.77,12.56L296.47,196.9s-8.36-9.53-8.14-15.1C288.53,177.07,291.14,172.89,296.61,173.62Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.61,173.62c4.29.58,10.77,12.56,10.77,12.56L296.47,196.9s-8.36-9.53-8.14-15.1C288.53,177.07,291.14,172.89,296.61,173.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333,393a.58.58,0,0,1-.14,0,1.15,1.15,0,0,1-.8-.8.69.69,0,0,1,.09-.69c.68-.87,3.78-.58,4.13-.55a.2.2,0,0,1,.17.15.21.21,0,0,1-.06.21C335.53,392,334,393.1,333,393Zm2.74-1.7c-1.24-.08-2.91,0-3.27.43a.3.3,0,0,0,0,.3.76.76,0,0,0,.52.55C333.5,392.68,334.53,392.21,335.71,391.25Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,391.27c-1-.15-3-1-3.23-1.88a.7.7,0,0,1,.34-.82,1,1,0,0,1,.89-.16c1.21.3,2.37,2.49,2.42,2.58a.22.22,0,0,1,0,.21.21.21,0,0,1-.18.09Zm-2.18-2.48a.64.64,0,0,0-.48.11c-.21.15-.21.28-.18.37.17.58,1.67,1.36,2.7,1.57-.42-.71-1.23-1.86-2-2Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23,407.85a3.44,3.44,0,0,1-2-.47,1.28,1.28,0,0,1-.51-1,.58.58,0,0,1,.25-.56c.93-.62,4.4,1,5.09,1.28a.19.19,0,0,1,.11.2.2.2,0,0,1-.16.18A13.86,13.86,0,0,1,271.23,407.85Zm-1.62-1.76a.72.72,0,0,0-.4.09.2.2,0,0,0-.08.19.86.86,0,0,0,.36.68c.6.45,2,.51,3.83.18A12.49,12.49,0,0,0,269.61,406.09Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,407.5h-.08c-1.15-.47-3.47-2.33-3.34-3.3,0-.21.17-.47.7-.53,2-.24,2.88,3.44,2.92,3.59a.21.21,0,0,1-.07.21A.2.2,0,0,1,274,407.5Zm-2.54-3.45h-.13c-.22,0-.33.09-.35.19-.07.56,1.53,2,2.71,2.67C273.4,406,272.66,404.05,271.44,404.05Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,148l-1.54-.78S269,148.67,269.94,148Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-169"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "116.84 408.01 124.87 407.89 126.71 389.27 118.69 389.39 116.84 408.01",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.1 408.04 85.13 408.04 88.28 389.45 80.26 389.45 77.1 408.04",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.24,407.11H76.45a.7.7,0,0,0-.68.55l-1.59,7.14a1.18,1.18,0,0,0,1.18,1.42c3.15-.05,5.44-.24,9.41-.24,2.44,0,9.8.26,13.17.26s3.81-3.33,2.43-3.64c-6.19-1.35-10.85-3.21-12.83-5A2,2,0,0,0,86.24,407.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,407l-8.77.14a.68.68,0,0,0-.67.55l-1.48,7.16a1.16,1.16,0,0,0,1.18,1.41c3.16-.1,7.73-.36,11.7-.42,4.65-.07,8.67.12,14.11,0,3.3-.05,4.16-3.39,2.78-3.67-6.3-1.28-11.43-1.35-16.91-4.61A3.74,3.74,0,0,0,124.8,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83,163.56c2.58,4.83,5.31,9.8,8.06,14.61s5.62,9.59,8.68,14c.37.57.77,1.09,1.16,1.62l.58.79.26.36.1.14a2.34,2.34,0,0,0,1,.82c1.08.47,3.36.41,5.66-.14a43.35,43.35,0,0,0,7.25-2.54c1.22-.55,2.46-1.1,3.67-1.72s2.45-1.28,3.57-1.88l3.73,4.74c-1.14,1.13-2.23,2.08-3.41,3s-2.35,1.89-3.61,2.75a41.7,41.7,0,0,1-8.29,4.56,26.19,26.19,0,0,1-5,1.44,16.45,16.45,0,0,1-6.12-.09,12.71,12.71,0,0,1-6.29-3.36c-.22-.21-.42-.43-.62-.65l-.41-.47-.75-.88c-.5-.58-1-1.17-1.47-1.76a143.54,143.54,0,0,1-10.12-14.57c-3-5-5.86-10-8.49-15.31Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53,163.8c-2.17,7.36,13.07,27.43,13.07,27.43L145,181.35a97.46,97.46,0,0,0-10.64-18C128,155.28,118.9,155.72,116.53,163.8Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53,163.8c-2.17,7.36,13.07,27.43,13.07,27.43L145,181.35a97.46,97.46,0,0,0-10.64-18C128,155.28,118.9,155.72,116.53,163.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,172.44c3.16,1.35,7.81,9,10.23,14.6l-6.52,4.19a122.8,122.8,0,0,1-9.8-15.36C121.86,173.61,124.22,171.73,125.89,172.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,190l5.6-3.33,4.8,8.34s-6.23,3.65-10.26-.59Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.59 186.75 186.1 193.18 180.56 195.01 175.76 186.67 183.59 186.75",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.71 389.27 125.76 398.87 117.73 399 118.68 389.4 126.71 389.27",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.25 389.46 88.28 389.46 86.65 399.04 78.62 399.04 80.25 389.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,160.54C89.39,191,88,223.38,88.52,230l42.9-1.61c7.29-45.45-5.8-70.75-5.8-70.75s-2.75-.53-6.49-.92c-1.18-.12-2.44-.22-3.76-.29-.73,0-1.47-.07-2.22-.08A160.08,160.08,0,0,0,95,157.66c-1.15.14-2.31.32-3.43.5s-2.07.37-3,.56C84.12,159.59,80.75,160.54,80.75,160.54Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,160.54C89.39,191,88,223.38,88.52,230l42.9-1.61c7.29-45.45-5.8-70.75-5.8-70.75s-2.75-.53-6.49-.92c-1.18-.12-2.44-.22-3.76-.29-.73,0-1.47-.07-2.22-.08A160.08,160.08,0,0,0,95,157.66c-1.15.14-2.31.32-3.43.5s-2.07.37-3,.56C84.12,159.59,80.75,160.54,80.75,160.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.88,173.62c.77,2.95-.11,16.41-3.19,19.73-.42-4.31-1-8.81-1.72-13.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,156.41l-.31,0c-.73,0-1.47-.07-2.22-.08a160.25,160.25,0,0,0-18.2,1.35c-.88.11-1.76.24-2.63.38l1.33,1.14c3.94,3.37,8.53,6.49,15.33,6.49h.87c3.47-.14,5.69-1.27,6.62-3.38A6.49,6.49,0,0,0,115.67,156.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.23,137c1.58,5.77,3.52,16.42-.28,20.63,3.42,2.93,7.85,6.27,14.82,6s5.4-5,3.38-7.35c-6.65-1.08-6.84-5.94-6-10.57Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,140.59l7,5.15a19.26,19.26,0,0,0-.32,3.27c-2.52-.18-6.15-2.66-6.61-5.25A8.7,8.7,0,0,1,100.07,140.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18,131.43c2.28,2.32,6.47-10.33,2-13.4S101,120,112.18,131.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,128.27c1.08,7.89,1.31,12.57,5.62,16.34,6.48,5.67,16,1.31,17.3-6.74,1.17-7.25-.79-18.94-8.78-21.52A10.87,10.87,0,0,0,93.87,128.27Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,135.42c2.59,2,4.86-11.17,0-13.54S82.1,125.79,94.9,135.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86,123.67c7.61,2.61,29,.18,25.22-15.39-1.61-6.72-8.89-1-9.39,2.72-3.72-3.06-10.63-2.39-9.82,2.5C93.86,112.33,78.7,116,91.86,123.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.94,137.28a7.57,7.57,0,0,0,5,3c2.63.38,3.6-2.06,2.58-4.36-.92-2.07-3.39-4.76-5.89-4.08S89.5,135.29,90.94,137.28Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74,397l-13.59.21s4.53-53.69,3.31-78.67c-.37-7.6-1.9-18.23-3.91-29.62-2.53-14.36-3.75-20.08-7-38.22-2.34-12.94-4.3-21.26-4.3-21.26l28.2-1.06s8.69,63.12,8.42,87.61C139.56,341.43,128.74,397,128.74,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,246c5.06,12.6,5.16,42.12,2.83,50.43-.4-2.46-.83-5-1.28-7.54-2.54-14.36-3.76-20.08-7-38.22-.06-.36-.13-.71-.19-1.06A19.5,19.5,0,0,1,113,246Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,228.92s-5.12,66.53-8.89,89.75c-4.12,25.42-16.94,78.51-16.94,78.51H75.68s4.85-48,7.86-73c3.42-28.4,5-94.25,5-94.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.14 397.5 74.83 397.5 74.83 392.33 94.18 391.99 92.14 397.5",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.14 397.5 74.83 397.5 74.83 392.33 94.18 391.99 92.14 397.5",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 397.26 114.26 397.51 114.17 392.28 132.27 391.72 130.45 397.26",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 397.26 114.26 397.51 114.17 392.28 132.27 391.72 130.45 397.26",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.07,129.59c0,.65.43,1.15.85,1.11s.72-.58.67-1.22-.42-1.14-.85-1.11S106,129,106.07,129.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,129.05c0,.65.43,1.14.86,1.11s.72-.58.67-1.22-.43-1.15-.85-1.12S113.32,128.4,113.36,129.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,129.54a23.13,23.13,0,0,0,3.49,5.3,3.71,3.71,0,0,1-3,.8Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,137.57a5.32,5.32,0,0,1-3.81-1.84.19.19,0,1,1,.31-.23,5.12,5.12,0,0,0,4.32,1.69.19.19,0,0,1,.2.17.19.19,0,0,1-.18.21A5.89,5.89,0,0,1,108.93,137.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.64,127.4a.3.3,0,0,1-.18-.06.38.38,0,0,1-.12-.52,3.79,3.79,0,0,1,3-1.8.38.38,0,1,1,0,.76h0a3,3,0,0,0-2.34,1.45A.36.36,0,0,1,103.64,127.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.32,126.31a.38.38,0,0,1-.3-.19,3.06,3.06,0,0,0-2.27-1.56.38.38,0,0,1,0-.76,3.79,3.79,0,0,1,2.88,1.93.37.37,0,0,1-.14.52A.39.39,0,0,1,116.32,126.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.89,408.52a9.76,9.76,0,0,1-2.1-.29.19.19,0,0,1-.14-.16.19.19,0,0,1,.09-.19c.29-.18,2.88-1.77,3.77-1.32a.63.63,0,0,1,.32.54,1.14,1.14,0,0,1-.39,1A2.49,2.49,0,0,1,88.89,408.52ZM87.34,408c1.37.27,2.41.22,2.85-.15a.74.74,0,0,0,.26-.68.25.25,0,0,0-.12-.23C89.87,406.66,88.4,407.35,87.34,408Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,408.23a.2.2,0,0,1-.11,0,.17.17,0,0,1-.08-.17c0-.1.2-2.42,1.13-3.18a1,1,0,0,1,.81-.24h0a.61.61,0,0,1,.6.49c.17.9-1.43,2.66-2.26,3.11ZM88.46,405a.64.64,0,0,0-.44.17,4.56,4.56,0,0,0-1,2.51c.83-.63,1.85-2,1.75-2.48,0-.05,0-.17-.28-.2h-.08Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,408.06a.2.2,0,0,1-.12-.16.17.17,0,0,1,.09-.19c.37-.2,3.57-1.88,4.55-1.36a.62.62,0,0,1,.32.51h0a1.06,1.06,0,0,1-.34.93c-.87.79-3.17.51-4.47.27Zm4.27-1.4c-.61-.2-2.35.49-3.61,1.12,1.78.27,3.1.17,3.58-.27a.69.69,0,0,0,.22-.62.22.22,0,0,0-.12-.2Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,408.06l0,0a.2.2,0,0,1-.09-.17c0-.09.19-2.26,1.2-3.11a1.37,1.37,0,0,1,1-.34h0c.52,0,.68.3.72.52.16.9-1.73,2.67-2.7,3.12A.22.22,0,0,1,125.6,408.06Zm2.28-3.24-.19,0h0a1,1,0,0,0-.77.26,4.45,4.45,0,0,0-1,2.49c1-.61,2.26-2,2.16-2.54C128.06,405,128,404.87,127.88,404.82Zm-.18-.22h0Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.63,170.85l-7.54,16.43c-1.23,2.75-2.49,5.48-3.66,8.24-.58,1.37-1.2,2.74-1.75,4.11l-.43,1c-.14.35-.22.59-.33.88-.23.56-.38,1.18-.57,1.77a33.24,33.24,0,0,0-1.1,7.83,59,59,0,0,0,.34,8.46c.31,2.86.78,5.75,1.38,8.63s1.32,5.82,2.1,8.55l-5.53,2.4c-.81-1.5-1.48-2.89-2.13-4.37s-1.25-2.93-1.82-4.43a74.86,74.86,0,0,1-2.82-9.24,49.25,49.25,0,0,1-.91-20.23c.2-.88.37-1.77.65-2.66l.38-1.3.37-1.13c.48-1.51,1-3,1.5-4.48,1.06-3,2.14-5.88,3.31-8.76,2.31-5.8,4.82-11.42,7.62-17Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,160.54c-7.32,2.3-14.52,27.13-14.52,27.13l16.94,7.41s5.48-12,8.63-21.4C95.24,163.43,89.62,157.76,80.75,160.54Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,160.54c-7.32,2.3-14.52,27.13-14.52,27.13l16.94,7.41s5.48-12,8.63-21.4C95.24,163.43,89.62,157.76,80.75,160.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.62,235.39l3.95,7.13-9.31,2.42s-2.82-6.91.51-9.11Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.26 250.61 73.71 251.32 72.26 244.94 81.57 242.52 82.26 250.61",
    style: {
      fill: "#b55b52"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puzzle--inject-169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,282.35a9.53,9.53,0,0,1-9.51,9.25H215.33a19.27,19.27,0,1,1-31.25,0H158.91a9.52,9.52,0,0,1-9.5-9.5V200.52a9.53,9.53,0,0,1,9.5-9.51h81.58a9.53,9.53,0,0,1,9.5,9.26v25.41a19.26,19.26,0,1,0,0,31.26V282.1A2.09,2.09,0,0,0,250,282.35Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,319.21a16.35,16.35,0,0,1-13.29-25.93l3.28-4.55H158.91a6.64,6.64,0,0,1-6.62-6.63V200.52a6.64,6.64,0,0,1,6.62-6.64h81.58a6.68,6.68,0,0,1,6.63,6.46v20.29a.13.13,0,0,1-.06.1.13.13,0,0,1-.12,0,21.83,21.83,0,0,0-8.17-1.57,22.14,22.14,0,1,0,0,44.27,21.71,21.71,0,0,0,8.17-1.57.13.13,0,0,1,.12,0,.13.13,0,0,1,.06.1v20.4a6.71,6.71,0,0,1-6.63,6.34H209.74l3.25,4.54a.13.13,0,0,1,0,.18.12.12,0,0,1-.17,0l-3.4-4.75a.12.12,0,0,1,0-.13.13.13,0,0,1,.11-.06h31a6.47,6.47,0,0,0,6.38-6.09V262.17a22.18,22.18,0,0,1-8.1,1.52,22.39,22.39,0,1,1,8.1-43.25V200.35a6.43,6.43,0,0,0-6.38-6.22H158.91a6.38,6.38,0,0,0-6.37,6.39V282.1a6.38,6.38,0,0,0,6.37,6.38h31a.11.11,0,0,1,.11.06.12.12,0,0,1,0,.13l-3.42,4.76a16,16,0,0,0-3.06,9.4,16.14,16.14,0,0,0,32.28,0,.12.12,0,0,1,.12-.12.12.12,0,0,1,.13.12A16.41,16.41,0,0,1,199.7,319.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,191H315.94a19.27,19.27,0,1,1-31.29,0H259.5a9.54,9.54,0,0,0-9.51,9.5v25.17a19.26,19.26,0,1,0,0,31.26V282.1a9.54,9.54,0,0,0,9.51,9.51h81.59a9.53,9.53,0,0,0,9.5-9.51V200.51A9.53,9.53,0,0,0,341.09,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,288.73H259.5a6.63,6.63,0,0,1-6.63-6.63V251.32l-4.55,3.28a16.36,16.36,0,0,1-25.93-13.29.12.12,0,0,1,.12-.13.13.13,0,0,1,.13.13,16.11,16.11,0,0,0,25.53,13.09l4.75-3.42a.13.13,0,0,1,.2.1v31a6.38,6.38,0,0,0,6.38,6.38h81.59a6.38,6.38,0,0,0,6.38-6.38V200.51a6.39,6.39,0,0,0-6.38-6.38H321.17a22.39,22.39,0,1,1-41.75,0H259.5a6.39,6.39,0,0,0-6.38,6.38v31a.15.15,0,0,1-.07.12.15.15,0,0,1-.13,0l-4.75-3.42a16,16,0,0,0-9.4-3.05.12.12,0,0,1-.12-.12.12.12,0,0,1,.12-.13,16.27,16.27,0,0,1,9.55,3.09l4.55,3.28V200.51a6.64,6.64,0,0,1,6.63-6.63h20.1a.14.14,0,0,1,.11.06.14.14,0,0,1,0,.11,21.92,21.92,0,0,0-1.56,8.19,22.14,22.14,0,0,0,44.27,0,21.92,21.92,0,0,0-1.56-8.19.11.11,0,0,1,0-.11.13.13,0,0,1,.11-.06h20.1a6.64,6.64,0,0,1,6.63,6.63V282.1A6.64,6.64,0,0,1,341.09,288.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/networking.84c592f7aab7fbe9bbc009827ddcdaee.svg";
export { ForwardRef as ReactComponent };